<template>
  <!-- Hamburger Button -->
  <button
    @click="toggleMenu"
    class="fixed top-6 right-6 z-50 w-12 h-12 flex flex-col justify-center items-center space-y-1 bg-secondary/20 backdrop-blur-sm rounded-full hover:bg-accent/20 transition-colors"
    aria-label="Toggle menu"
  >
    <span
      :class="[
        'w-6 h-0.5 bg-foreground block transition-transform duration-300',
        isOpen ? 'rotate-45 translate-y-1' : '',
      ]"
    ></span>
    <span
      :class="[
        'w-6 h-0.5 bg-foreground block transition-opacity duration-300',
        isOpen ? 'opacity-0' : '',
      ]"
    ></span>
    <span
      :class="[
        'w-6 h-0.5 bg-foreground block transition-transform duration-300',
        isOpen ? '-rotate-45 -translate-y-1' : '',
      ]"
    ></span>
  </button>

  <!-- Menu Overlay + Panel -->
  <transition name="fade">
    <div
      v-if="isOpen"
      class="fixed inset-0 z-40 bg-background/95 backdrop-blur-md"
      @click="toggleMenu"
    >
      <!-- Slide Menu -->
      <transition name="slide">
        <div
          class="absolute right-0 top-0 w-full max-w-md h-full bg-background border-l border-accent/20 p-8 pt-24"
          @click.stop
        >
          <div class="space-y-8">
            <div>
              <h1 class="text-3xl font-bold mb-2">Rob Rickard</h1>
              <div class="w-12 h-0.5 bg-accent"></div>
            </div>

            <nav class="space-y-6">
              <router-link
                to="/"
                class="block text-xl transition-colors"
                :class="{
                  'text-accent': isActiveRoute('/'),
                  'text-foreground hover:text-accent': !isActiveRoute('/'),
                }"
                @click="closeMenu"
              >
                Home
              </router-link>
              <router-link
                to="/accomplishments"
                class="block text-xl transition-colors"
                :class="{
                  'text-accent': isActiveRoute('/accomplishments'),
                  'text-foreground hover:text-accent': !isActiveRoute('/accomplishments'),
                }"
                @click="closeMenu"
              >
                Timeline & Accomplishments
              </router-link>
              <router-link
                to="/contact"
                class="block text-xl transition-colors"
                :class="{
                  'text-accent': isActiveRoute('/contact'),
                  'text-foreground hover:text-accent':
                    !isActiveRoute('/contact'),
                }"
                @click="closeMenu"
              >
                Contact
              </router-link>
            </nav>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script setup>
import { ref } from "vue";
import { useRoute} from "vue-router";

const isOpen = ref(false);
const route = useRoute();

function toggleMenu() {
  isOpen.value = !isOpen.value;
}
function closeMenu() {
  isOpen.value = false;
}
function isActiveRoute(path) {
  return route.path === path;
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}
.slide-enter-from {
  transform: translateX(100%);
}
.slide-leave-to {
  transform: translateX(100%);
}
</style>
